import React from "react";
import { ArrowRight, Activity } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
function NewsGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="20881" className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-[400px] w-full bg-muted/20 animate-pulse border border-border" />)}
      </div>;
  }
  if (error) {
    return <div className="text-destructive">Error loading clinical insights.</div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-secondary">No wellness articles available at the moment.</div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="group flex flex-col h-full bg-card border border-border/50 hover:border-accent/40 transition-colors duration-300 shadow-sm">
          {}
          <div className="relative aspect-[4/3] overflow-hidden border-b border-border bg-muted">
            {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" /> : <div className="w-full h-full flex items-center justify-center bg-muted text-secondary">
                <Activity className="w-12 h-12 opacity-20" />
              </div>}
            
            {}
            <div className="absolute top-4 left-4 z-10">
              <Badge variant="default" className="bg-accent text-accent-foreground hover:bg-accent border-none rounded-lg px-4 py-1 uppercase tracking-widest text-[10px] font-bold shadow-md">
                {post.categories?.[0]?.name || "Wellness"}
              </Badge>
            </div>
          </div>

          {}
          <div className="flex flex-col flex-grow p-6 relative">
            <h3 className="text-2xl font-serif font-medium leading-tight text-primary mb-4 line-clamp-3">
              {post.title}
            </h3>
            
            <div className="mt-auto pt-4 border-t border-border/50 flex items-center justify-between">
              <span className="text-xs text-secondary font-sans uppercase tracking-widest">
                {post.date ? new Date(post.date).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }) : 'Recent Update'}
              </span>
              
              <Link to={post.link || "#"} className="group/link inline-flex items-center justify-center w-10 h-10 text-accent hover:text-accent/80 transition-colors" aria-label={`Read more about ${post.title}`}>
                <ArrowRight className="w-6 h-6 transition-transform duration-300 group-hover/link:translate-x-2" />
              </Link>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function InstituteNews() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="latest-wellness-news" className="py-20 md:py-28 bg-background border-t border-border/40">
      <h1 className="sr-only">Health Insights</h1>
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6 border-b border-border/50 pb-8">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl font-serif font-medium text-primary tracking-tight mb-4">Health <span className="text-accent">Insights</span></h2>
            <p className="text-secondary text-lg max-w-xl font-sans">
              Expert advice on chiropractic care, acupuncture, and holistic wellness from our Limassol and Nicosia clinics.
            </p>
          </div>
          
          <div className="hidden md:block">
             <div className="h-1 w-24 bg-accent/30 rounded-lg"></div>
          </div>
        </div>

        <PostsProvider wp_query={{
        per_page: 3,
        orderby: "date",
        order: "desc",
        status: ["publish"]
      }} className="w-full">
          <NewsGrid />
        </PostsProvider>
      </div>
    </section>;
}